import * as ActionTypes from '../../../constants/actionTypes';

const setUser = (payload) => ({
  type: ActionTypes.SECURITY_USERS_SET,
  payload,
});

const setImpersonateUserAsUser = (user) => ({
  type: ActionTypes.SECURITY_IMPERSONATE_FETCH,
  user,
});

export {
  setUser, setImpersonateUserAsUser,
};
